import React from 'react';
import { NavLink } from 'react-router-dom';
import { makeStyles, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { COLORS } from 'constants/index';

const useStyles = makeStyles({
  navLink: {
    '&.active': {
      backgroundColor: COLORS.BLUE_50,
      '& .MuiListItemIcon-root svg': {
        fill: `${COLORS.BLUE}`,
      },
      '& .MuiTypography-root': {
        color: `${COLORS.BLUE}`,
      }
    },
  }
});

export interface NavigationLink {
  label: string;
  icon: React.ReactElement;
  to: string;
  isActive?: boolean;
  exact?: boolean;
  onClick?: () => void;
};

// Note: Example pulled from Material UI docs
// https://material-ui.com/guides/composition/#caveat-with-inlining
const ListItemLink: React.SFC<NavigationLink> = (props) => {
  const { icon, exact, label, to, isActive, onClick } = props;
  const classes = useStyles();
  const activeClass = isActive ? 'active' : ''

  const CustomLink = React.useMemo(
    () =>
      React.forwardRef((linkProps: any, ref: any) => (
        <NavLink
          ref={ref}
          to={to}
          exact={exact}
          {...linkProps}
          className={`${linkProps.className} ${activeClass}`}
        />
      )),
    [to, exact, activeClass],
  );

  return (
    <li>
      <ListItem
        className={classes.navLink}
        button
        component={CustomLink as any}
        onClick={() => onClick && onClick()}
      >
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText primary={label} />
      </ListItem>
    </li>
  )
}

export default ListItemLink;
